module.exports = __webpack_public_path__ + "static/scrabblista-mobile-3.350e19f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project/scrabblista/img/scrabblista-mobile-3.png
// module id = 627
// module chunks = 230197332751855